// extracted by mini-css-extract-plugin
export default {"customCheckbox":"Checkbox_customCheckbox__gFUcZ"};